import { createContext, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { generateServicetypePath } from "../components/common/callback/callback";
import { redirectToPiOnboardingIdentification } from "../components/piOnboarding/steps/helpers";
import useServiceType from "../hooks/useServiseType";
import { clearPersistedIdentificationStatus } from "../utils/constants/piFormSession";

export const GlobalContext = createContext(null);
export const GlobaContextProvider = ({ children }) => {
  const initialState = {
    status: "",
    person: null,
    additionalInfo: null,
    localToken: "",
  };
  const [globalData, setGlobalData] = useState(initialState);
  const [shown, setShown] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [countries, setCountries] = useState([]);

  const [creditDebitCountries, setCreditDebitCountries] = useState([]);
  const [fullCountries, setFullCountries] = useState([]);
  const [legalCountries, setLegalCountries] = useState([]);
  const [legalForms, setLegalForms] = useState([]);
  const [monthlyTurnovers, setMonthlyTurnovers] = useState([]);
  const [federalTaxes, setFederalTaxes] = useState([]);
  const [showBlockedModal, setShowBlockedModal] = useState(false);
  const { serviceType } = useServiceType();
  const { i18n } = useTranslation();
  const history = useHistory();

  function resetGlobalData() {
    setGlobalData(initialState);
    clearPersistedIdentificationStatus();
  }
  const catchError = (error, catchParams) => {
    if (error) {
      setErrorMessage(error.response.data?.Message);
      setShown(true);
      if (error.response.status === 401) {
        if (catchParams?.withoutRedirect) return;
        return history.push(
          generateServicetypePath("/agreement", serviceType, i18n)
        );
      }
      if (!catchParams?.withoutRedirect) {
        history.push(generateServicetypePath("/agreement", serviceType, i18n));
      }
    }
  };

  const catchErrorPIOnboarding = (error, catchParams) => {
    if (error) {
      setErrorMessage(error.response.data?.Message);
      setShown(true);
      if (error.response.status === 401) {
        redirectToPiOnboardingIdentification();
        return;
      }
    }
  };

  return (
    <GlobalContext.Provider
      value={{
        globalData,
        setGlobalData,
        resetGlobalData,
        setCountries,
        setFullCountries,
        fullCountries,
        countries,
        creditDebitCountries,
        setCreditDebitCountries,
        setShown,
        shown,
        setErrorMessage,
        errorMessage,
        showBlockedModal,
        setShowBlockedModal,
        catchError,
        catchErrorPIOnboarding,
        legalCountries,
        setLegalCountries,
        legalForms,
        setLegalForms,
        monthlyTurnovers,
        setMonthlyTurnovers,
        federalTaxes,
        setFederalTaxes,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export function useGlobalContext() {
  const value = useContext(GlobalContext);
  if (!value) {
    throw new Error("Global Context Provider is not defined");
  }
  return value;
}
